// extracted by mini-css-extract-plugin
export var box = "styles-module--box--2t-zs";
export var text = "styles-module--text--3ngMh";
export var divider = "styles-module--divider--3ErGA";
export var link = "styles-module--link--CefGf";